import config from "config/config"
import axios from "axios"

import * as url from "../helpers/url_helper"

export const examMasterApi = {
  addExamStepOne: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Exam_Step_one}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }
    return await axios(axiosConfig)
  },

  addExamStepTwo: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Exam_Step_two}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }
    return await axios(axiosConfig)
  },

  addExamStepThree: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Exam_Step_three}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }
    return await axios(axiosConfig)
  },

  getExam: async (page = 1, search = "", sessionId = null) => {
    const params = new URLSearchParams({ page })
    if (search.trim()) params.append("search", search.trim())
    if (sessionId) params.append("session_id", sessionId)
    var axiosConfig = {
      method: "GET",
      url: `${config.API_URL}${url.Exam_Get}?${params.toString()}`,
      headers: {
        "Content-Type": "application/json",
      },
    }
    return await axios(axiosConfig)
  },

  getExamById: async (examId, sessionId = null) => {
    const params = new URLSearchParams({ exam_id: examId })
    if (sessionId) params.append("session_id", sessionId)
    var axiosConfig = {
      method: "GET",
      url: `${config.API_URL}${url.Exam_Get}?${params.toString()}`,
      headers: {
        "Content-Type": "application/json",
      },
    }
    return await axios(axiosConfig)
  },

  deleteExam: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Exam_Delete}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }

    return await axios(axiosConfig)
  },

  updateExamStatus: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Exam_IsActive}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }
    return await axios(axiosConfig)
  },
}
